export function syncPhoneSelectCountry(code: string, numPS = '1') {
  if (!code) return
  const normalized = code === 'BY' ? 'BY_BY' : code
  sessionStorage.setItem(`selectedCountryPhoneSelect${numPS}`, normalized)
}
